<template>
  <pro-layout
    :menus="menus"
    :collapsed="collapsed"
    :mediaQuery="query"
    :isMobile="isMobile"
    :handleMediaQuery="handleMediaQuery"
    :handleCollapse="handleCollapse"
    :i18nRender="i18nRender"
    v-bind="settings"
  >
    <!-- Ads begin
      广告代码 真实项目中请移除
      production remove this Ads
    -->
    <!-- <ads v-if="isProPreviewSite && !collapsed"/> -->
    <!-- Ads end -->

    <!-- layout content -->
    <!-- 2021.01.15 默认固定页头，去掉样式paddingTop: fixedHeader ? '64' : '0'  -->
    <a-layout-content :style="{ height: '100%', margin: '0 0 0px 0'}">
      <multi-tab v-if="settings.multiTab"></multi-tab>
      <transition name="page-transition">
      </transition>
    </a-layout-content>
    <!-- 1.0.0+ 版本 pro-layout 提供 API，
          我们推荐使用这种方式进行 LOGO 和 title 自定义
    -->
    <template v-slot:menuHeaderRender>
      <div>
        <img src="~@/assets/logo.png" class="logo" alt="logo">
        <h1>{{ title }}</h1>
      </div>
    </template>

    <setting-drawer v-if="isProPreviewSite" :settings="settings" @change="handleSettingChange" />
    <template v-slot:rightContentRender>
      <right-content :top-menu="settings.layout === 'topmenu'" :is-mobile="isMobile" :theme="settings.theme" />
    </template>
    <template v-slot:footerRender v-if="!hideFooter">
      <global-footer />
    </template>
    <keep-alive :include="this.cachedViews">
      <router-view :key="key" />
    </keep-alive>
    <cs-menu-badge-iframe v-if="showCsBadgeIframe" />
  </pro-layout>
</template>

<script>
import MultiTab from '@/components/MultiTab'
import { updateTheme } from '@/components/ProLayout'
import SettingDrawer from '@/components/SettingDrawer'
import { i18nRender } from '@/locales'
import { mapState } from 'vuex'
import { refreshDocumentTitle } from '@/utils/domUtil'
import {
  CONTENT_WIDTH_TYPE,
  SIDE_COLLAPSED,
  TOGGLE_MOBILE_TYPE,
  TOGGLE_CONTENT_WIDTH,
  TOGGLE_FIXED_HEADER,
  TOGGLE_FIXED_SIDEBAR,
  TOGGLE_LAYOUT,
  TOGGLE_NAV_THEME,
  TOGGLE_WEAK,
  TOGGLE_COLOR,
  TOGGLE_MULTI_TAB,
  TABLE_SIZE,
  TABLE_BORDERED,
  HIDE_FOOTER
} from '@/store/mutation-types'

import defaultSettings from '@/config/defaultSettings'
import RightContent from '@/components/GlobalHeader/RightContent'
import GlobalFooter from '@/components/GlobalFooter'
import Ads from '@/components/Other/CarbonAds'
import { baseMixin } from '@/store/app-mixin'
import { applyMenuAuditBadges } from '@/utils/menuBadge'
import { POLL_INTERVAL_MS } from '@/store/modules/auditReminder'
import CsMenuBadgeIframe from '@/components/CsMenuBadgeIframe'
import { navigateToCsWorkbench } from '@/utils/csEmbed'
import { csAlertDismiss, csAlertDismissLatest } from '@/api/customer-service/order'

const CS_ALERT_DISMISS_POLL_MS = 1500

export default {
  name: 'BasicLayout',
  components: {
    SettingDrawer,
    RightContent,
    GlobalFooter,
    Ads,
    MultiTab,
    CsMenuBadgeIframe
  },
  mixins: [baseMixin],
  data () {
    return {
      // preview.pro.antdv.com only use.是否展示设置页面样式按钮；先写死 true;后续可根据 process.env.VUE_APP_PREVIEW === 'true', 进行控制
      isProPreviewSite: true,//process.env.VUE_APP_PREVIEW === 'true',
      // end
      // base
      menus: [],
      auditPollTimer: null,
      // 侧栏展开状态
      collapsed: false,
      title: defaultSettings.title,
      settings: {
        // 布局类型
        layout: defaultSettings.layout, // 'sidemenu', 'topmenu'
        // CONTENT_WIDTH_TYPE
        contentWidth: defaultSettings.layout === 'sidemenu' ? CONTENT_WIDTH_TYPE.Fluid : defaultSettings.contentWidth,
        // 主题 'dark' | 'light'
        theme: defaultSettings.navTheme,
        // 主色调
        primaryColor: defaultSettings.primaryColor,
        fixedHeader: defaultSettings.fixedHeader,
        fixSiderbar: defaultSettings.fixSiderbar,
        multiTab: defaultSettings.multiTab,
        colorWeak: defaultSettings.colorWeak,

        hideHintAlert: true,
        hideCopyButton: false,
        tableSize: defaultSettings.tableSize,
        tableBordered: defaultSettings.tableBordered,
        hideFooter: defaultSettings.hideFooter
      },
      // 媒体查询
      query: {},
      csUnreadBaseline: 0,
      csAcknowledgedUnread: 0,
      csAcknowledgedPending: 0,
      csUnreadNotifyReady: false,
      csNotifyTimer: null,
      csModalOpen: false,
      csConfirmModal: null,
      csDismissBaseline: 0,
      csAlertDismissPollTimer: null,
      csLocalDismissAt: 0,
      csIframeWarmup: false,
      csIframeWarmupTimer: null
    }
  },
  computed: {
    ...mapState({
      // 动态主路由
      mainMenu: state => state.permission.menus,
      auditRedeemPending: state => state.auditReminder.redeemPending,
      auditWithdrawPending: state => state.auditReminder.withdrawPending,
      csUnreadTotal: state => state.csMessageReminder.unreadTotal
    }),
    pendingNoticeTotal () {
      return this.$store.getters.pendingNoticeTotal || 0
    },
    cachedViews () {
      return this.$store.state.tagsView.cachedViews
    },
    key () {
      return this.$route.path
    },
    showCsBadgeIframe () {
      return !this.isOnWorkbenchPage
    },
    isOnWorkbenchPage () {
      const path = this.$route.path || ''
      return path.includes('customer-service/workbench') || path.endsWith('/workbench')
    }
  },
  watch: {
    isOnWorkbenchPage (onWorkbench, wasOnWorkbench) {
      if (onWorkbench) {
        this.acknowledgeCsCountsFromStore()
        return
      }
      if (wasOnWorkbench) {
        this.acknowledgeCsCountsFromStore()
        this.startCsIframeWarmup()
      }
    },
    pendingNoticeTotal () {
      refreshDocumentTitle()
    }
  },
  created () {
    const routes = this.mainMenu.find(item => item.path === '/')
    this.refreshMenus(routes)
    this.startAuditPolling()
    refreshDocumentTitle()
    // 处理侧栏展开状态
    this.$watch('collapsed', () => {
      this.$store.commit(SIDE_COLLAPSED, this.collapsed)
    })
    this.$watch('mainMenu', () => {
      const root = this.mainMenu.find(item => item.path === '/')
      this.refreshMenus(root)
    })
    this.$watch('auditRedeemPending', () => {
      const root = this.mainMenu.find(item => item.path === '/')
      this.refreshMenus(root)
    })
    this.$watch('auditWithdrawPending', () => {
      const root = this.mainMenu.find(item => item.path === '/')
      this.refreshMenus(root)
    })
    this.$watch('csUnreadTotal', () => {
      const root = this.mainMenu.find(item => item.path === '/')
      this.refreshMenus(root)
    })
  },
  beforeDestroy () {
    this.stopAuditPolling()
    this.stopCsAlertDismissPoll()
    this.destroyCsConfirmModal(false)
    window.removeEventListener('message', this.onCsUnreadMessage)
    if (this.csNotifyTimer) {
      clearTimeout(this.csNotifyTimer)
      this.csNotifyTimer = null
    }
    if (this.csIframeWarmupTimer) {
      clearTimeout(this.csIframeWarmupTimer)
      this.csIframeWarmupTimer = null
    }
  },
  mounted () {
    window.addEventListener('message', this.onCsUnreadMessage)
    if (this.isProPreviewSite) {
      this.settings.layout = this.layout
      this.settings.contentWidth = this.contentWidth
      this.settings.theme = this.navTheme
      this.settings.primaryColor = this.primaryColor
      this.settings.fixedHeader = this.fixedHeader
      this.settings.fixSiderbar = this.fixedSidebar
      this.settings.multiTab = this.multiTab
      this.settings.colorWeak = this.colorWeak
      this.settings.tableSize = this.tableSize
      this.settings.tableBordered = this.tableBordered
      this.settings.hideFooter = this.hideFooter
    }
    this.collapsed = this.sideCollapsed
    const userAgent = navigator.userAgent
    if (userAgent.indexOf('Edge') > -1) {
      this.$nextTick(() => {
        this.collapsed = !this.collapsed
        setTimeout(() => {
          this.collapsed = !this.collapsed
        }, 16)
      })
    }

    // first update color
    // TIPS: THEME COLOR HANDLER!! PLEASE CHECK THAT!!
    if (process.env.NODE_ENV !== 'production' || process.env.VUE_APP_PREVIEW === 'true') {
      updateTheme(this.settings.primaryColor)
    }
  },
  methods: {
    refreshMenus (routes) {
      const children = (routes && routes.children) || []
      const perms = this.$store.getters.permissions || []
      const all = perms.includes('*:*:*')
      this.menus = applyMenuAuditBadges(children, {
        redeemPending: (all || perms.includes('giftcard:redeem:list')) ? this.auditRedeemPending : 0,
        withdrawPending: (all || perms.includes('giftcard:withdraw:list')) ? this.auditWithdrawPending : 0,
        csUnread: (all || perms.includes('customer:workbench:view')) ? this.csUnreadTotal : 0
      })
    },
    startAuditPolling () {
      this.fetchAuditCounts()
      this.auditPollTimer = setInterval(() => {
        this.fetchAuditCounts()
      }, POLL_INTERVAL_MS)
    },
    stopAuditPolling () {
      if (this.auditPollTimer) {
        clearInterval(this.auditPollTimer)
        this.auditPollTimer = null
      }
    },
    fetchAuditCounts () {
      this.$store.dispatch('auditReminder/fetchAuditPendingCount')
    },
    onCsUnreadMessage (event) {
      const data = event.data
      if (!data || data.type !== 'CS_UNREAD_COUNT') {
        return
      }
      // 无客服工作台权限时不写入未读，避免铃铛/侧栏误提示
      if (!this.canViewCsWorkbench()) {
        this.$store.dispatch('csMessageReminder/updateCounts', {
          unreadCount: 0,
          pendingCount: 0,
          unreadTotal: 0
        })
        return
      }
      const unreadCount = this.toCsCount(data.unreadCount)
      const pendingCount = this.toCsCount(data.pendingCount)
      const unreadTotal = this.toCsCount(data.unreadTotal) || (unreadCount + pendingCount)
      this.$store.dispatch('csMessageReminder/updateCounts', {
        unreadCount,
        pendingCount,
        unreadTotal
      })
      this.handleCsCountsUpdate(unreadCount, pendingCount, unreadTotal)
    },
    toCsCount (value) {
      const n = Number(value)
      return Number.isFinite(n) && n > 0 ? Math.floor(n) : 0
    },
    canViewCsWorkbench () {
      const perms = this.$store.getters.permissions || []
      return perms.includes('customer:workbench:view') || perms.includes('*:*:*')
    },
    acknowledgeCsCounts (unreadCount, pendingCount) {
      this.csAcknowledgedUnread = this.toCsCount(unreadCount)
      this.csAcknowledgedPending = this.toCsCount(pendingCount)
    },
    acknowledgeCsCountsFromStore () {
      const state = this.$store.state.csMessageReminder || {}
      this.acknowledgeCsCounts(state.unreadCount, state.pendingCount)
      this.csModalOpen = false
    },
    destroyCsConfirmModal (ack) {
      if (this.csConfirmModal && typeof this.csConfirmModal.destroy === 'function') {
        try {
          this.csConfirmModal.destroy()
        } catch (e) { /* ignore */ }
      }
      this.csConfirmModal = null
      this.stopCsAlertDismissPoll()
      if (ack) {
        this.acknowledgeCsCountsFromStore()
      } else {
        this.csModalOpen = false
      }
    },
    startCsAlertDismissPoll () {
      this.stopCsAlertDismissPoll()
      this.pollCsAlertDismiss()
      this.csAlertDismissPollTimer = setInterval(() => {
        this.pollCsAlertDismiss()
      }, CS_ALERT_DISMISS_POLL_MS)
    },
    stopCsAlertDismissPoll () {
      if (this.csAlertDismissPollTimer) {
        clearInterval(this.csAlertDismissPollTimer)
        this.csAlertDismissPollTimer = null
      }
    },
    pollCsAlertDismiss () {
      if (!this.csModalOpen) {
        this.stopCsAlertDismissPoll()
        return
      }
      csAlertDismissLatest().then(res => {
        const data = (res && res.data) || {}
        if (!data.active || !data.dismissAt) {
          return
        }
        const dismissAt = Number(data.dismissAt) || 0
        // 用服务端时间戳比较，忽略弹窗打开前的旧信号，以及自己刚发出的广播
        if (dismissAt <= this.csDismissBaseline || dismissAt <= this.csLocalDismissAt) {
          return
        }
        this.csDismissBaseline = dismissAt
        this.destroyCsConfirmModal(true)
      }).catch(() => {})
    },
    broadcastCsAlertDismiss (pendingCount) {
      const now = Date.now()
      this.csLocalDismissAt = now
      csAlertDismiss(pendingCount).then(res => {
        const data = (res && res.data) || {}
        if (data.dismissAt) {
          const dismissAt = Number(data.dismissAt) || now
          this.csLocalDismissAt = dismissAt
          this.csDismissBaseline = Math.max(this.csDismissBaseline, dismissAt)
        }
      }).catch(() => {})
    },
    startCsIframeWarmup () {
      this.csIframeWarmup = true
      if (this.csIframeWarmupTimer) {
        clearTimeout(this.csIframeWarmupTimer)
      }
      this.csIframeWarmupTimer = setTimeout(() => {
        this.csIframeWarmup = false
        this.csIframeWarmupTimer = null
      }, 5000)
    },
    handleCsCountsUpdate (unreadCount, pendingCount, unreadTotal) {
      if (!this.canViewCsWorkbench()) {
        return
      }
      if (!this.csUnreadNotifyReady) {
        this.csUnreadNotifyReady = true
        this.acknowledgeCsCounts(unreadCount, pendingCount)
        this.csUnreadBaseline = unreadTotal
        return
      }
      this.csUnreadBaseline = unreadTotal
      // 待接入已被别人接走：弹窗自动关掉
      if (this.csModalOpen && pendingCount === 0) {
        this.destroyCsConfirmModal(true)
        return
      }
      if (this.isOnWorkbenchPage || this.csIframeWarmup) {
        this.acknowledgeCsCounts(unreadCount, pendingCount)
        return
      }
      const hasNewUnread = unreadCount > this.csAcknowledgedUnread
      const hasNewPending = pendingCount > this.csAcknowledgedPending
      if (!hasNewUnread && !hasNewPending) {
        return
      }
      if (this.csModalOpen) {
        return
      }
      if (this.csNotifyTimer) {
        clearTimeout(this.csNotifyTimer)
      }
      this.csNotifyTimer = setTimeout(() => {
        this.showCsMessageModal({
          unreadTotal,
          unreadCount,
          pendingCount,
          hasNewUnread,
          hasNewPending
        })
      }, 400)
    },
    showCsMessageModal ({ unreadTotal, unreadCount, pendingCount, hasNewUnread, hasNewPending }) {
      const self = this
      const unreadDelta = unreadCount - this.csAcknowledgedUnread
      const pendingDelta = pendingCount - this.csAcknowledgedPending
      const parts = []
      if (hasNewPending && pendingDelta > 0) {
        parts.push(`${pendingCount} 条待接入会话${pendingDelta > 1 ? `（新增 ${pendingDelta} 条）` : ''}`)
      }
      if (hasNewUnread && unreadDelta > 0) {
        parts.push(`${unreadCount} 条未读消息${unreadDelta > 1 ? `（新增 ${unreadDelta} 条）` : ''}`)
      }
      let title = '客服消息提醒'
      if (hasNewPending && !hasNewUnread) {
        title = '客服待接入提醒'
      } else if (hasNewUnread && !hasNewPending) {
        title = '客服新消息提醒'
      }
      const content = parts.length
        ? `您有 ${parts.join('、')}，请尽快接待处理。`
        : `您有 ${unreadTotal} 条待处理客服消息，请尽快接待处理。`
      const finishAlert = () => {
        self.stopCsAlertDismissPoll()
        self.csConfirmModal = null
        self.csModalOpen = false
        const state = self.$store.state.csMessageReminder || {}
        const ackUnread = Math.max(self.toCsCount(state.unreadCount), unreadCount)
        const ackPending = Math.max(self.toCsCount(state.pendingCount), pendingCount)
        self.acknowledgeCsCounts(ackUnread, ackPending)
      }
      this.destroyCsConfirmModal(false)
      this.csModalOpen = true
      this.csDismissBaseline = 0
      this.csConfirmModal = this.$confirm({
        title,
        content,
        okText: '立即处理',
        cancelText: '稍后',
        onOk () {
          self.broadcastCsAlertDismiss(pendingCount)
          finishAlert()
          return new Promise((resolve) => {
            self.$nextTick(() => {
              navigateToCsWorkbench(self.$router, self.$store)
              resolve()
            })
          })
        },
        onCancel () {
          finishAlert()
        }
      })
      // 先拉取当前基线，再轮询，避免旧信号误关
      csAlertDismissLatest().then(res => {
        const data = (res && res.data) || {}
        if (data.dismissAt) {
          this.csDismissBaseline = Number(data.dismissAt) || 0
        }
        if (this.csModalOpen) {
          this.startCsAlertDismissPoll()
        }
      }).catch(() => {
        if (this.csModalOpen) {
          this.startCsAlertDismissPoll()
        }
      })
    },
    i18nRender,
    handleMediaQuery (val) {
      this.query = val
      if (this.isMobile && !val['screen-xs']) {
        this.$store.commit(TOGGLE_MOBILE_TYPE, false)
        return
      }
      if (!this.isMobile && val['screen-xs']) {
        this.$store.commit(TOGGLE_MOBILE_TYPE, true)
        this.collapsed = true
        this.settings.contentWidth = CONTENT_WIDTH_TYPE.Fluid
        // this.settings.fixSiderbar = false
      }
    },
    handleCollapse (val) {
      this.collapsed = val
    },
    handleSettingChange ({ type, value }) {
      type && (this.settings[type] = value)
      switch (type) {
        case 'theme':
          this.$store.commit(TOGGLE_NAV_THEME, value)
          break
        case 'primaryColor':
          this.$store.commit(TOGGLE_COLOR, value)
          break
        case 'contentWidth':
          this.settings[type] = value
          this.$store.commit(TOGGLE_CONTENT_WIDTH, value)
          break
        case 'layout':
          this.$store.commit(TOGGLE_LAYOUT, value)
          if (value === 'sidemenu') {
            this.settings.contentWidth = CONTENT_WIDTH_TYPE.Fluid
            this.$store.commit(TOGGLE_CONTENT_WIDTH, CONTENT_WIDTH_TYPE.Fluid)
          } else {
            this.settings.fixSiderbar = false
            this.$store.commit(TOGGLE_FIXED_SIDEBAR, false)
            this.settings.contentWidth = CONTENT_WIDTH_TYPE.Fixed
            this.$store.commit(TOGGLE_CONTENT_WIDTH, CONTENT_WIDTH_TYPE.Fixed)
          }
          break
        case 'fixSiderbar':
          this.$store.commit(TOGGLE_FIXED_SIDEBAR, value)
          break
        case 'fixedHeader':
          this.$store.commit(TOGGLE_FIXED_HEADER, value)
          break
        case 'multiTab':
          this.$store.commit(TOGGLE_MULTI_TAB, value)
          break
        case 'colorWeak':
          this.$store.commit(TOGGLE_WEAK, value)
          break
        case 'tableSize':
          this.$store.commit(TABLE_SIZE, value)
          break
        case 'tableBordered':
          this.$store.commit(TABLE_BORDERED, value)
          break
        case 'hideFooter':
          this.$store.commit(HIDE_FOOTER, value)
          break
      }
    }
  }
}
</script>

<style lang="less">
@import "./BasicLayout.less";
</style>
